import { 
  criticalComponentFactory, 
  importantComponentFactory, 
  deferredComponentFactory 
} from '@utils';


// Critical - Components needed for immediate interaction
// These will be preloaded with highest priority
const CriticalComponents = {
  ['product-gallery']: criticalComponentFactory('ui/ProductGallery'),
  ['mobile-product-gallery']: criticalComponentFactory('ui/MobileProductGallery'),
  ['quick-add-to-cart']: criticalComponentFactory('ui/quick-add-to-cart'),
  ProductForm: criticalComponentFactory('ui/ProductForm'),
  ProductVariantSelector: criticalComponentFactory('ui/VariantSelector'),
  QuantityInput: criticalComponentFactory('ui/QuantityInput'),
  Slider: criticalComponentFactory('ui/Slider'),
  Modal: criticalComponentFactory('ui/Modal'),
  LazyLoader: criticalComponentFactory('ui/LazyLoader'),
}

// Important - Components needed soon after page load
// These will be prefetched when browser is idle
const ImportantComponents = {
  QuickSearch: importantComponentFactory('ui/QuickSearch'),
  MainCart: importantComponentFactory('ui/Cart/MainCart'),
  MiniCart: importantComponentFactory('ui/MiniCart'),
  DesktopNav: importantComponentFactory('nav/DesktopNav'),
  MobileNav: importantComponentFactory('nav/MobileNav'),
}

// Deferred - Components needed for later interaction
// These will be loaded on demand when user interacts with them
const DeferredComponents = {
  Accordion: deferredComponentFactory('ui/Accordion'),
  CustomSelect: deferredComponentFactory('ui/CustomSelect'),
  Drawer: deferredComponentFactory('ui/Drawer'),
  FacetFilters: deferredComponentFactory('ui/FacetFilters'),
  Tabs: deferredComponentFactory('ui/Tabs'),
  ['video-player']: deferredComponentFactory('media/VideoPlayer'),
  WufooForm: deferredComponentFactory('ui/WufooForm'),
}

const AppComponents = {
  ...CriticalComponents,
  ...ImportantComponents,
  ...DeferredComponents,
};

export default AppComponents;
